import { FC, HTMLAttributes, ReactNode } from 'react';

import { css, styled } from '@mui/material';

export const TicketStyledSummaryItem: FC<
  { children: ReactNode } & HTMLAttributes<HTMLSpanElement>
> = ({ children, ...rest }) => {
  return <StyledItem {...rest}>{children}</StyledItem>;
};

const StyledItem = styled('span')(
  ({ theme }) => css`
    position: relative;

    &:not(:first-of-type) {
      margin-left: ${theme.spacing(12)};
    }

    &:not(:last-of-type) {
      padding-right: ${theme.spacing(12)};

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        height: 20px;
        width: 1px;
        background-color: ${theme.palette.natural.border};
      }
    }
  `
);
